module.exports = __webpack_public_path__ + "static/media/gryphon.20546e04.jpg";